const formatCentsAsCurrency = (amountInCents) => {
  const amount = Number(amountInCents || 0) / 100;
  return `$${amount.toFixed(2)}`;
};

export const formatBookingDiscountLabel = (item) => {
  const referralDiscountAmount = Number(item?.referral_discount_amount || 0);
  const promotionDiscountAmount = Number(item?.promotion_discount_amount || 0);
  const creditDiscountAmount = Number(item?.credit_discount_amount || 0);
  const labels = [];

  if (referralDiscountAmount > 0) {
    labels.push(`Referral ${formatCentsAsCurrency(referralDiscountAmount)}`);
  }

  if (promotionDiscountAmount > 0) {
    labels.push(`Code ${formatCentsAsCurrency(promotionDiscountAmount)}`);
  }

  if (creditDiscountAmount > 0) {
    labels.push(`Credits ${formatCentsAsCurrency(creditDiscountAmount)}`);
  }

  if (!labels.length) {
    return '-';
  }

  return labels.join('\n');
};
